import { render, staticRenderFns } from "./GiftersComponent.vue?vue&type=template&id=858b69ba&scoped=true&"
import script from "./GiftersComponent.vue?vue&type=script&lang=ts&"
export * from "./GiftersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GiftersComponent.vue?vue&type=style&index=0&id=858b69ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858b69ba",
  null
  
)

export default component.exports